import { render } from "./FileUpload.vue?vue&type=template&id=57e0fd85&scoped=true&ts=true"
import script from "./FileUpload.vue?vue&type=script&lang=ts"
export * from "./FileUpload.vue?vue&type=script&lang=ts"

import "./FileUpload.vue?vue&type=style&index=0&id=57e0fd85&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e0fd85"]])

export default __exports__